import Icon from '@ui/icons/icon';
import Button from '@ui/buttons/button/button';
import Container from '@ui/container/container';

interface IconToggleProps {
  leftIconName: string;
  leftValue: string | number;
  rightIconName: string;
  rightValue: string | number;
  onToggle: () => void;
  selected: string | number;
  dataComponent?: string;
}

export default function IconToggle({
  leftIconName,
  leftValue,
  rightIconName,
  rightValue,
  onToggle,
  selected,
  dataComponent = 'IconToggle',
}: IconToggleProps) {
  const leftSelected = leftValue === selected;
  const rightSelected = rightValue === selected;

  return (
    <Container
      data-component={dataComponent}
      className="flex ai-center height-32 width-64 jc-space-evenly"
      background="var(--gray-1200)"
      borderRadius="100px"
    >
      <Button
        onClick={onToggle}
        className="padding-6 height-27 width-27 flex ai-center jc-center"
        backgroundColor={leftSelected ? 'var(--gray-700)' : 'none'}
        style={{ color: leftSelected ? 'var(--gray-100)' : 'var(--gray-500)' }}
      >
        <Icon name={leftIconName} size={12} />
      </Button>
      <Button
        onClick={onToggle}
        className="padding-6 height-27 width-27 flex ai-center jc-center"
        backgroundColor={rightSelected ? 'var(--gray-700)' : 'none'}
        style={{ color: rightSelected ? 'var(--gray-100)' : 'var(--gray-500)' }}
      >
        <Icon name={rightIconName} size={12} />
      </Button>
    </Container>
  );
}
